import { createFileRoute, redirect } from '@tanstack/react-router';

declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    /** Render the "My Groups" rail on the right of the main content instead of the left. */
    railRight?: boolean;
  }
}

export const Route = createFileRoute('/_authenticated/dashboard')({
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
});
